import { useEffect, useState } from 'preact/hooks';
import { Icon } from '../Icon';

export const BUBBLE_TTL_MS = 6000;
export const EMOTE_TTL_MS = 2000;
export const MAX_BUBBLES = 12;

// bridge.bubbles entries (written by B1): { id, text, x, y, at, kind?: 'say'|'emote', emote?: id }
// x/y are screen px (bubble tail point); `at` is the creation time in ms (performance.now/Date.now clock of `now`).
export const EMOTE_ICON = { wave: 'waving-hand01', hail: 'crown', ehen: 'thumbs-up' };

/** Live bubbles at `now`: unexpired, newest 12. */
export function liveBubbles(list, now) {
    const live = list.filter((b) => now - b.at < (b.kind === 'emote' ? EMOTE_TTL_MS : BUBBLE_TTL_MS));
    return live.length > MAX_BUBBLES ? live.slice(live.length - MAX_BUBBLES) : live;
}

export function BubbleLayer({ bridge, now = () => Date.now() }) {
    const [t, setT] = useState(now());
    useEffect(() => {
        const id = setInterval(() => setT(now()), 250);
        return () => clearInterval(id);
    }, []);
    const list = liveBubbles(bridge.bubbles.value, t);
    return (<div class="bubble-layer" aria-live="polite">
      {list.map((b) => {
        const left = t - b.at > (b.kind === 'emote' ? EMOTE_TTL_MS : BUBBLE_TTL_MS) - 500;
        return (<div key={b.id} class={`bubble${left ? ' is-fading' : ''}`} data-id={b.id} style={`transform:translate(${Math.round(b.x)}px,${Math.round(b.y)}px) translate(-50%,-100%)`}>
          {b.kind === 'emote' ? <Icon name={EMOTE_ICON[b.emote] ?? 'thumbs-up'} label={b.emote}/> : b.text}
        </div>);
      })}
    </div>);
}
